import React, { useEffect, useId, useState } from "react";
import { CloseCircle } from "iconsax-reactjs";
import { MAX_CAPTION_LENGTH } from "../../utils/reelsShared";
import "./reels.css";

/** Caption editing for a reel the signed-in dealer owns. */
export default function ReelCaptionModal({ reel, busy, onSave, onClose }) {
  const [caption, setCaption] = useState(reel?.caption || "");
  const titleId = useId();
  const inputId = useId();
  const hintId = useId();

  useEffect(() => {
    setCaption(reel?.caption || "");
  }, [reel]);

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape" && !busy) onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [busy, onClose]);

  if (!reel) return null;

  const trimmed = caption.trim();
  const unchanged = trimmed === (reel.caption || "").trim();

  return (
    <div className="modal-overlay" onClick={() => !busy && onClose()}>
      <div
        className="modal reel-caption-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
      >
        <div className="modal-header">
          <h2 id={titleId}>Edit caption</h2>
          <button type="button" className="btn-icon" onClick={onClose} aria-label="Close">
            <CloseCircle size={20} variant="Linear" />
          </button>
        </div>

        <div className="modal-body">
          <div className="field">
            <label className="field-label" htmlFor={inputId}>Caption</label>
            <textarea
              id={inputId}
              className="textarea"
              value={caption}
              maxLength={MAX_CAPTION_LENGTH}
              rows={4}
              onChange={(e) => setCaption(e.target.value)}
              placeholder="Describe the property in a line or two"
              aria-describedby={hintId}
            />
            <div className="reel-field-row">
              <span id={hintId} className="field-hint">Shown under your reel in the feed.</span>
              <span className="reel-char-count">
                {caption.length}/{MAX_CAPTION_LENGTH}
              </span>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button type="button" className="btn-secondary" onClick={onClose} disabled={busy}>
            Cancel
          </button>
          <button
            type="button"
            className="btn-primary"
            onClick={() => onSave(trimmed)}
            disabled={busy || unchanged}
          >
            {busy && <span className="btn-spinner" aria-hidden="true" />}
            {busy ? "Saving…" : "Save caption"}
          </button>
        </div>
      </div>
    </div>
  );
}
